import { render, staticRenderFns } from "./profile-detail.vue?vue&type=template&id=15f03f4d&scoped=true&"
import script from "./profile-detail.vue?vue&type=script&lang=js&"
export * from "./profile-detail.vue?vue&type=script&lang=js&"
import style0 from "./profile-detail.vue?vue&type=style&index=0&id=15f03f4d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f03f4d",
  null
  
)

export default component.exports